import Container from '@ui/container/container';

const TableListSparseSkeletonLoader = () => {
  const tableHead = () => {
    return (
      <Container className="flex fd-row" height="64px" width="997px">
        {/* checkbox */}
        <Container
          height="64px"
          width="62px"
          skLoader={{
            height: 22,
            width: 22,
            radius: 8,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />

        <Container
          height="64px"
          width="164px"
          skLoader={{
            height: 22,
            width: 130,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />

        <Container
          height="64px"
          width="214px"
          skLoader={{
            height: 22,
            width: 130,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        <Container
          height="64px"
          width="246px"
          skLoader={{
            height: 22,
            width: 150,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        <Container
          height="64px"
          width="141px"
          skLoader={{
            height: 22,
            width: 85,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        <Container
          height="64px"
          width="105px"
          skLoader={{
            height: 22,
            width: 105,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
      </Container>
    );
  };

  const tableRow = (idx: number) => {
    return (
      <Container
        key={idx}
        className="flex fd-row"
        height="64px"
        width="997px"
        style={{ borderTop: '1px solid var(--gray-700)' }}
      >
        {/* checkbox */}
        <Container
          height="64px"
          width="62px"
          skLoader={{
            height: 22,
            width: 22,
            radius: 8,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />

        {/* full name */}
        <Container className="flex fd-row ai-center" height="64px" width="164px">
          <Container
            height="64px"
            width="38px"
            skLoader={{
              height: 32,
              width: 32,
              radius: 100,
              loading: true,
              design: 'GlobalCont1',
              justify: 'flex-start',
            }}
          />
          <Container className="flex fd-column" height="32px">
            <Container
              height="16px"
              width="100px"
              skLoader={{
                height: 12,
                width: 100,
                radius: 4,
                loading: true,
                design: 'GlobalCont1',
              }}
            />
            <Container
              height="16px"
              width="100px"
              skLoader={{
                height: 12,
                width: 100,
                radius: 4,
                loading: true,
                design: 'GlobalCont1',
              }}
            />
          </Container>
        </Container>

        <Container
          height="64px"
          width="214px"
          skLoader={{
            height: 22,
            width: 120,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        <Container
          height="64px"
          width="244px"
          skLoader={{
            height: 22,
            width: 80,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        <Container
          height="64px"
          width="144px"
          skLoader={{
            height: 22,
            width: 120,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        <Container
          height="64px"
          width="120px"
          skLoader={{
            height: 22,
            width: 104,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
      </Container>
    );
  };

  const pagingRow = () => {
    return (
      <Container className="flex fd-row gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <Container
            key={i}
            height="64px"
            width="32px"
            skLoader={{
              height: 32,
              width: 32,
              radius: 100,
              loading: true,
              design: 'GlobalCont1',
            }}
          />
        ))}
      </Container>
    );
  };

  return (
    <Container className="flex fd-column">
      <Container className="flex fd-column" height="calc(100vh - 340px)" style={{ overflowY: 'hidden' }}>
        {tableHead()}
        {Array.from({ length: 10 }).map((_, i) => tableRow(i))}
        {pagingRow()}
      </Container>
    </Container>
  );
};

export default TableListSparseSkeletonLoader;
